/* Free-shipping progress bar (replaces the older bar in reyca-custom.js).
   Thresholds: Canada $100 (Quebec & Ontario) / $150 (rest of Canada), United States $150.
   Gift boxes that ship at a flat rate are left out of the total. */
(function () {
  'use strict';
  var GOALS = { CA: 100, US: 150 };
  var CA_FAR = 150;
  var FLAT_RATE_VARIANTS = [67502331822238];

  var st = document.createElement('style');
  st.textContent = '.rq-ship{display:none!important}' +
    '.rq-free{margin:0 0 16px;padding:14px 16px;border:1px solid #E6DFCB;border-radius:12px;background:rgba(255,255,255,.5)}' +
    '#CartDrawer .rq-free{margin:4px 20px 12px}.rq-free[hidden]{display:none!important}' +
    '.rq-free__msg{margin:0 0 10px;font-size:14px;line-height:1.4;color:#2C2A28;text-align:center}' +
    '.rq-free__msg strong{font-weight:600;color:#16301F}' +
    '.rq-free__note{display:block;margin-top:3px;font-size:12px;color:#8B8885}' +
    '.rq-free__track{position:relative;height:6px;border-radius:999px;background:#EFE8D6;overflow:hidden}' +
    '.rq-free__fill{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:inherit;background:#16301F;transition:width .5s ease}' +
    '.rq-free.is-free .rq-free__fill{background:#3F6B4E}';
  document.head.appendChild(st);

  var S = window.Shopify || {};
  var country = (S.country || 'CA').toUpperCase();
  var base = GOALS[country];
  if (!base) return;

  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var cur = (S.currency && S.currency.active) || 'CAD';
  var rate = parseFloat((S.currency && S.currency.rate) || '1') || 1;
  var goal = Math.round(base * rate * 100);
  var farGoal = Math.round(CA_FAR * rate * 100);
  var root = (S.routes && S.routes.root) || '/';
  var state = null;

  function money(cents) {
    var v = cents / 100;
    var digits = v % 1 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(isFr ? 'fr-CA' : (cur === 'USD' ? 'en-US' : 'en-CA'),
        { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return '$' + v.toFixed(2); }
  }

  function text(s) {
    var left = goal - s.total;
    var main, note = '';
    if (left > 0) {
      main = isFr ? 'Plus que <strong>' + money(left) + '</strong> pour la livraison gratuite'
                  : 'You’re <strong>' + money(left) + '</strong> away from free shipping';
      if (country === 'CA') note = isFr ? 'Dès ' + money(goal) + ' au Québec et en Ontario, ' + money(farGoal) + ' ailleurs au Canada'
                                         : 'From ' + money(goal) + ' in Quebec and Ontario, ' + money(farGoal) + ' elsewhere in Canada';
    } else if (country === 'CA' && s.total < farGoal) {
      main = isFr ? '<strong>Bonne nouvelle!</strong> Livraison gratuite au Québec et en Ontario.'
                  : '<strong>Good news!</strong> Free shipping in Quebec and Ontario.';
      note = isFr ? 'Ailleurs au Canada : gratuite dès ' + money(farGoal)
                  : 'Elsewhere in Canada: free from ' + money(farGoal);
    } else {
      main = isFr ? '<strong>Bonne nouvelle!</strong> Votre livraison est gratuite.'
                  : '<strong>Good news!</strong> Your shipping is free.';
    }
    if (s.hasBox) note += (note ? '. ' : '') + (isFr ? 'Les boîtes cadeaux sont expédiées à tarif fixe.' : 'Gift boxes ship at a flat rate.');
    return main + (note ? '<span class="rq-free__note">' + note + '</span>' : '');
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'rq-free';
    el.setAttribute('role', 'status');
    el.innerHTML = '<p class="rq-free__msg"></p><div class="rq-free__track"><span class="rq-free__fill"></span></div>';
    return el;
  }

  function paint(el) {
    if (!state) return;
    el.hidden = state.total <= 0;
    var pct = Math.max(0, Math.min(100, state.total / goal * 100));
    el.classList.toggle('is-free', pct >= 100);
    var msg = text(state);
    var m = el.querySelector('.rq-free__msg');
    if (m.innerHTML !== msg) m.innerHTML = msg;
    el.querySelector('.rq-free__fill').style.width = pct + '%';
  }

  function mount() {
    var h = document.querySelector('#CartDrawer .cart-drawer__heading');
    if (h && !h.parentNode.querySelector('.rq-free')) h.insertAdjacentElement('afterend', build());
    var page = document.querySelector('.shopify-section[id$="__cart-template"] form[action*="/cart"]');
    if (page && !page.parentNode.querySelector(':scope > .rq-free')) page.insertAdjacentElement('beforebegin', build());
    document.querySelectorAll('.rq-free').forEach(paint);
  }

  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var total = 0, hasBox = false;
        (c.items || []).forEach(function (it) {
          if (FLAT_RATE_VARIANTS.indexOf(it.variant_id) > -1) hasBox = true;
          else total += it.final_line_price;
        });
        state = { total: total, hasBox: hasBox };
        mount();
      })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  function init() {
    refresh();
    var tc = window.themeCore;
    if (tc && tc.EventBus && tc.EventBus.listen) {
      try { tc.EventBus.listen('cart:updated', function () { refresh(); }); } catch (e) {}
    }
    var t;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.closest && !n.closest('.rq-free') && (n.closest('#CartDrawer') || n.closest('.shopify-section[id$="__cart-template"]'))) {
          clearTimeout(t); t = setTimeout(refresh, 150); return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
